import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
// eslint-disable-next-line import/no-unresolved, import/extensions
import Icon from '../../../common/containers/icon';
import { getAllHeaders, normalizeValue, downloadCSV } from './qualityAgentHelpers';
const FollowupAnalysisResults = _ref => {
  var _followup$analysis;
  let followup = _ref.followup,
    followupId = _ref.followupId;
  const hasExecutionRows = ((_followup$analysis = followup.analysis) === null || _followup$analysis === void 0 || (_followup$analysis = _followup$analysis.execution) === null || _followup$analysis === void 0 || (_followup$analysis = _followup$analysis.rows) === null || _followup$analysis === void 0 ? void 0 : _followup$analysis.length) > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Analysis Summary"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium"
  }, followup.analysis.summary)), hasExecutionRows && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Evidence (", followup.analysis.execution.rowCount, " row", followup.analysis.execution.rowCount !== 1 ? 's' : '', ")"), /*#__PURE__*/React.createElement(Button, {
    color: "outline-secondary",
    size: "sm",
    onClick: e => {
      e.stopPropagation();
      downloadCSV(followup.analysis.execution.rows, "followup-".concat(followupId, "-evidence"));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "download",
    style: {
      marginRight: 6
    }
  }), "Download CSV")), /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, (() => {
    const headers = getAllHeaders(followup.analysis.execution.rows);
    return /*#__PURE__*/React.createElement("table", {
      className: "table table-sm table-bordered small mb-0"
    }, /*#__PURE__*/React.createElement("thead", {
      className: "table-light"
    }, /*#__PURE__*/React.createElement("tr", null, headers.map(key => /*#__PURE__*/React.createElement("th", {
      key: "header-".concat(key)
    }, key)))), /*#__PURE__*/React.createElement("tbody", null, followup.analysis.execution.rows.slice(0, 5).map((row, rowIndex) => {
      const rowKey = row.id != null && row.id !== '' ? "row-".concat(rowIndex, "-id-").concat(String(row.id)) : "row-".concat(rowIndex, "-").concat(JSON.stringify(row).substring(0, 50));
      return /*#__PURE__*/React.createElement("tr", {
        key: rowKey
      }, headers.map(key => /*#__PURE__*/React.createElement("td", {
        key: "cell-".concat(key, "-").concat(rowKey)
      }, normalizeValue(row[key]))));
    })));
  })())), followup.analysis.recommendations && /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Recommendations"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium",
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, followup.analysis.recommendations)));
};
FollowupAnalysisResults.propTypes = {
  followup: PropTypes.shape({
    analysis: PropTypes.shape({
      summary: PropTypes.string,
      execution: PropTypes.shape({
        rows: PropTypes.arrayOf(PropTypes.shape({})),
        rowCount: PropTypes.number
      }),
      recommendations: PropTypes.string
    })
  }).isRequired,
  followupId: PropTypes.string.isRequired
};
export default FollowupAnalysisResults;